import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Calendar, Home, TrendingUp, Users, IndianRupee, Clock } from 'lucide-react';
import AdminSidebar from '../../components/AdminSidebar';
import api from '../../utils/api';
import { toast } from 'sonner';

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await api.get('/dashboard/stats');
      setStats(response.data);
    } catch (error) {
      toast.error('Failed to load dashboard stats');
    } finally {
      setLoading(false);
    }
  };

  const statCards = stats ? [
    {
      icon: <Home size={28} />,
      label: 'Total Rooms',
      value: stats.total_rooms,
      color: '#1A3C34',
    },
    {
      icon: <Calendar size={28} />,
      label: 'Available Rooms',
      value: stats.available_rooms,
      color: '#8F9E8B',
    },
    {
      icon: <Users size={28} />,
      label: 'Occupied Rooms',
      value: stats.occupied_rooms,
      color: '#C67D63',
    },
    {
      icon: <TrendingUp size={28} />,
      label: 'Total Bookings',
      value: stats.total_bookings,
      color: '#1A3C34',
    },
    {
      icon: <Clock size={28} />,
      label: "Today's Check-ins",
      value: stats.today_checkins,
      color: '#8F9E8B',
    },
    {
      icon: <Clock size={28} />,
      label: "Today's Check-outs",
      value: stats.today_checkouts,
      color: '#C67D63',
    },
    {
      icon: <IndianRupee size={28} />,
      label: 'Total Revenue',
      value: `₹${stats.total_revenue.toFixed(2)}`,
      color: '#1A3C34',
    },
    {
      icon: <Calendar size={28} />,
      label: 'Pending Payments',
      value: stats.pending_payments,
      color: '#C67D63',
    },
  ] : [];

  return (
    <div className="flex" style={{ background: '#F9F8F6' }}>
      <AdminSidebar />
      <div className="admin-content flex-1" data-testid="admin-dashboard">
        <div className="mb-8">
          <h1
            className="text-4xl font-bold mb-2"
            style={{ fontFamily: 'Playfair Display, serif', color: '#1A3C34' }}
          >
            Dashboard
          </h1>
          <p style={{ color: '#64748B' }}>Welcome to your admin dashboard</p>
        </div>

        {loading ? (
          <div className="text-center py-20">
            <p style={{ color: '#64748B' }}>Loading stats...</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {statCards.map((card, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
                className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all"
                data-testid={`stat-card-${index}`}
              >
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center mb-4"
                  style={{ background: `${card.color}15`, color: card.color }}
                >
                  {card.icon}
                </div>
                <p className="text-sm mb-1" style={{ color: '#64748B' }}>
                  {card.label}
                </p>
                <p
                  className="text-3xl font-bold mono"
                  style={{ color: '#1A3C34' }}
                >
                  {card.value}
                </p>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;